import React from 'react';

import FormikDatePicker from 'src/components/formik-date-picker';

const TestDate = () => (
  <FormikDatePicker
    monthLabel="Test Month"
    monthName="month"
    yearLabel="Test Year"
    yearName="year"
    required
  />
);

export default TestDate;
